<template>
  <div :class="$style.flexContainer">
    <component
      :is="iconComponent(item)"
      v-if="iconComponent(item)"
      :class="$style.icon"
    />
    <!-- Show title and subtitle as clickable links in aside panels -->
    <div
      v-if="showAsLink || inDetailsAsidePanel"
      :class="$style.container"
    >
      <a
        :class="getTitleClassNames"
        :href="href"
        target="_self"
        :title="title"
        @click="closeModal"
      >
        {{ title }}
      </a>
      <a
        :class="[$style.subtitle, { [$style.showAsLink]: !title }]"
        :href="href"
        target="_self"
        :title="subtitle"
        @click="closeModal"
      >
        {{ subtitle }}
      </a>
    </div>
    <div
      v-else
      :class="$style.container"
    >
      <span
        :class="getTitleClassNames"
        :title="title"
      >
        {{ title }}
      </span>
      <span
        :class="$style.subtitle"
        :title="subtitle"
      >
        {{ subtitle }}
      </span>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import { getDetailsRoute } from 'client/util/Constants';
import ModalEventBus from 'components/Modal/ModalEventBus';

export default {
  name: 'ItemName',

  props: {
    iconComponent: {
      type: Function,
      default: () => '',
    },
    /* Show title and subtitle as clickable links in aside panels */
    inDetailsAsidePanel: Boolean,
    indirectItem: {
      default: '',
      type: String,
    },
    item: {
      default: () => ({}),
      type: Object,
    },
    itemType: {
      default: '',
      type: String,
    },
    showAsLink: {
      default: false,
      type: Boolean,
    },
    subtitleField: {
      default: '',
      type: String,
    },
    subtitleFunction: {
      default: null,
      type: Function,
    },
    subtitleValue: {
      default: '',
      type: String,
    },
    titleField: {
      default: '',
      type: String,
    },
    titleFunction: {
      default: null,
      type: Function,
    },
    titleValue: {
      default: '',
      type: String,
    },
    useMspStyles: Boolean,
  },

  computed: {
    computedItem() {
      const { item, indirectItem } = this;

      if (indirectItem) {
        return get(item, indirectItem, '');
      }

      return item;
    },

    getTitleClassNames() {
      return {
        [this.$style.title]: true,
        [this.$style.showAsLink]: this.showAsLink || this.inDetailsAsidePanel,
        [this.$style.mspTitle]: this.useMspStyles,
      };
    },

    href() {
      return getDetailsRoute(this.itemType, this.computedItem);
    },

    subtitle() {
      const { item, subtitleField, subtitleValue } = this;

      if (item && this.subtitleFunction) {
        return this.subtitleFunction(item);
      }

      if (item && subtitleField) {
        return get(item, subtitleField, '');
      }

      return subtitleValue;
    },

    title() {
      const { item, titleField, titleValue } = this;

      if (item && this.titleFunction) {
        return this.titleFunction(item);
      }

      if (item && titleField) {
        return get(item, titleField, '');
      }

      return titleValue;
    },
  },

  methods: {
    closeModal() {
      ModalEventBus.close();
    },
  },
};
</script>

<style scoped module>
@import '../../../css/flex.css';

@value (gradientDark1, gradientDark2) from '~css/colors.css';

.flexContainer {
  align-items: center;
}

.container {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.icon {
  height: 24px;
  margin-right: 7px;
  width: 24px;
}

.title {
  color: gradientDark1;
  font-size: 1.077rem;
  font-weight: 700;
  vertical-align: middle;
}

.title:hover {
  color: gradientDark1;
}

.mspTitle {
  font-weight: 300;
}

.subtitle {
  color: gradientDark2;
  display: block;
  font-size: 0.85rem;
  font-weight: 400;
  margin-top: 3px;
}

.subtitle:hover {
  color: gradientDark2;
  text-decoration: none;
}

.showAsLink.showAsLink {
  text-decoration: underline;
}

.showAsLink:hover {
  cursor: pointer;
}
</style>
